import { ActionModeType } from "src/app/model";

export interface GenerateFormFieldModel {
  name: string;
  path: string;
  fieldType: 'text' | 'number' | 'dropdown' | 'inputDropdown' | 'description' | 'input';
  fieldValue: any;
  initialValue?: any;
  displayId?: string;
  validator?: 'email' | 'required';
  isMultiSelect?: boolean;
}

export interface GenerateFormFieldDataModel {
  [s: string]: string[];
}

export interface GenerateFormModel {
  actionType: ActionModeType;
  formValue: GenerateFormFieldDataModel[];
}